import { createFeatureSelector, createSelector } from '@ngrx/store';

import { calculatorFeatureKey, State } from '../reducers/calculator.reducer';

export const selectCalculatorFeature = createFeatureSelector<State>(calculatorFeatureKey);

export const selectPitiData = createSelector(selectCalculatorFeature, (state) => ({
  buyerName: state.pitiBuyerName,
  downPayment: state.pitiDownPayment,
  interestRate: state.pitiInterestRate,
  monthlyHomeownersInsurance: state.pitiMonthlyHomeownersInsurance,
  monthlyPayment: state.pitiMonthlyPayment,
  mortgageAmount: state.pitiMortgageAmount,
  mortgageTerm: state.pitiMortgageTerm,
  principalAndInterest: state.pitiPrincipalAndInterest,
  privateMortgageInsurance: state.pitiPrivateMortgageInsurance,
  propertyTax: state.pitiPropertyTax,
  purchasePrice: state.pitiPurchasePrice
}));

export const selectPitiMortgageTerm = createSelector(selectPitiData, (state) => state.mortgageTerm);

export const selectAffordabilityData = createSelector(selectCalculatorFeature, (state) => ({
  buyerName: state.affordabilityBuyerName,
  downPayment: state.affordabilityDownPayment,
  interestRate: state.affordabilityInterestRate,
  monthlyHomeownersInsurance: state.affordabilityMonthlyHomeownersInsurance,
  monthlyPayment: state.affordabilityMonthlyPayment,
  mortgageAmount: state.affordabilityMortgageAmount,
  mortgageTerm: state.affordabilityMortgageTerm,
  principalAndInterest: state.affordabilityPrincipalAndInterest,
  privateMortgageInsurance: state.affordabilityPrivateMortgageInsurance,
  propertyTax: state.affordabilityPropertyTax,
  purchasePrice: state.affordabilityPurchasePrice
}));

export const selectAffordabilityMortgageTerm = createSelector(selectAffordabilityData, (state) => state.mortgageTerm);

export const selectAmortizationData = createSelector(selectCalculatorFeature, (state) => ({
  amount: state.amortizationAmount,
  interestRate: state.amortizationInterestRate,
  mortgageTerm: state.amortizationMortgageTerm,
  reportData: state.amortizationReportData
}));

export const selectAmortizationMortgageTerm = createSelector(selectAmortizationData, (state) => state.mortgageTerm);

export const selectAmortizationReportData = createSelector(selectAmortizationData, (state) => state.reportData);
